import React from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import ConfirmDialog from '../overlays/ConfirmDialog';

const iconMap = {
    asktext: 'bi-chat-square-text', phone: 'bi-telephone', email: 'bi-envelope',
    date: 'bi-calendar3', number: 'bi-hash', loc: 'bi-geo-alt',
    url: 'bi-link-45deg', file: 'bi-file-earmark',
};
const colorMap = {
    asktext: ['#2388e0','#1565c0'], phone:   ['#0891b2','#0e7490'],
    email:   ['#d97706','#b45309'], date:    ['#db2777','#be185d'],
    number:  ['#16a34a','#15803d'], loc:     ['#dc2626','#b91c1c'],
    url:     ['#ea580c','#c2410c'], file:    ['#7c3aed','#6d28d9'],
};
const labelMap = {
    asktext:'Ask Text', phone:'Ask Phone', email:'Ask Email', date:'Ask Date',
    number:'Ask Number', loc:'Ask Location', url:'Ask URL', file:'Ask File',
};

function AskNode({ id, data, selected }) {
    const { setNodes, setEdges, getNode } = useReactFlow();
    const [showDelete, setShowDelete] = React.useState(false);
    const nodeType = data.nodeType || 'asktext';
    const [c1, c2] = colorMap[nodeType] || ['#2388e0','#1565c0'];
    const icon     = iconMap[nodeType] || 'bi-question-circle';
    const label    = labelMap[nodeType] || 'Ask';

    const confirmDelete = () => {
        setShowDelete(false);
        setNodes(n => n.filter(x => x.id !== id));
        setEdges(e => e.filter(x => x.source !== id && x.target !== id));
    };
    const handleDuplicate = (e) => {
        e.stopPropagation();
        const node = getNode(id);
        if (!node) return;
        setNodes(n => [...n, { ...node, id:`node_${Date.now()}`, position:{ x:node.position.x+30, y:node.position.y+30 }, selected:false }]);
    };

    return (
        <div style={{ width:200, background:'#fff', border:`2px solid ${selected ? c1 : '#e5e7eb'}`, borderRadius:10, boxShadow:'0 2px 8px rgba(0,0,0,0.08)', overflow:'hidden' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'7px 10px', background:`linear-gradient(to right, ${c1}, ${c2})` }}>
                <div style={{ display:'flex', alignItems:'center', gap:6, color:'#fff', fontSize:11, fontWeight:700 }}>
                    <i className={`bi ${icon}`} style={{ fontSize:12 }}></i> {label}
                </div>
                <div style={{ display:'flex', gap:4 }}>
                    <button onClick={handleDuplicate} style={btnStyle}><i className="bi bi-copy" style={{ fontSize:10 }}></i></button>
                    <button onClick={e => { e.stopPropagation(); setShowDelete(true); }} style={btnStyle}><i className="bi bi-x" style={{ fontSize:12 }}></i></button>
                </div>
            </div>
            <div style={{ padding:'8px 10px' }}>
                <p style={{ fontSize:11, color:'#374151', fontWeight:500, lineHeight:1.4, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', margin:0 }}>
                    {data.text || 'No question set'}
                </p>
                {data.variable && <p style={{ fontSize:10, color:'#9ca3af', fontFamily:'monospace', marginTop:4, marginBottom:0 }}>→ {data.variable}</p>}
                {data.validation?.attempts > 1 && <p style={{ fontSize:10, color:'#9ca3af', marginTop:2, marginBottom:0 }}>Attempts: {data.validation.attempts}</p>}
            </div>
            <Handle id="a" type="target" position={Position.Left} style={hs(c1)}/>
            <Handle id="b" type="source" position={Position.Right} style={hs(c1)}/>
            {showDelete && <ConfirmDialog message={`Delete "${data.label || 'this node'}"?`} onConfirm={confirmDelete} onCancel={() => setShowDelete(false)}/>}
        </div>
    );
}

const btnStyle = { background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,0.8)', padding:2, display:'flex', alignItems:'center' };
const hs = (color) => ({ width:10, height:10, background:color, border:'2px solid #fff', borderRadius:'50%' });

export default AskNode;
